import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { FirstAccessRequest } from '../../requests/admin-user/first-access.request';

@Injectable({
  providedIn: 'root'
})
export class FirstAccessService extends CommonService{
  
  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public firstAccessPassword(firstAccessRequest: FirstAccessRequest): Observable<ReturnStruct>{
    return this.httpClient.post<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiAdminUser) + `FirstAccess`, firstAccessRequest)
    .pipe(
      catchError(this.handleError)
    )
  }
}
